import { Injectable, LOCALE_ID, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private readonly LANGUAGE_KEY = 'selected_language';

  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(LOCALE_ID) private localeId: string
  ) {
    this.setRTL();
  }

  private setRTL(): void {
    if (this.getCurrentLanguage() === 'ar') {
      this.document.documentElement.setAttribute('dir', 'rtl');
      this.document.documentElement.setAttribute('lang', 'ar');
      this.document.body.classList.add('rtl');
    }
  }

  getCurrentLanguage(): 'en' | 'ar' {
    return this.localeId.startsWith('ar') ? 'ar' : 'en';
  }

  switchLanguage(lang: 'en' | 'ar'): void {
    // Save preference
    localStorage.setItem(this.LANGUAGE_KEY, lang);
    window.location.href = '/' + lang + '/';
  }

  getDisplayName(): string {
    return this.getCurrentLanguage() === 'ar' ? 'العربية' : 'English';
  }

  getSavedLanguage(): 'en' | 'ar' | null {
    try {
      const saved = localStorage.getItem(this.LANGUAGE_KEY);
      return (saved === 'ar' || saved === 'en') ? saved : null;
    } catch {
      return null;
    }
  }
}